function getCategorySaveErrorMessage(errorCode) {
    switch(errorCode) {
        case "SLUG_ALREADY_EXISTS":
            return "Deze slug bestaat al binnen deze shop.";
        case "MISSING_PARAMETERS":
        case "INVALID_PARAMETERS":
            return "Vul een titel en geldige slug in.";
        case "DOESNT_EXIST":
            return "Deze categorie bestaat niet of hoort niet bij deze shop.";
        case "DATABASE_ERROR":
        default:
            return "Er ging iets fout. Probeer het later opnieuw.";
    }
}

export default getCategorySaveErrorMessage;
